import { defineComponent as h, inject as C, computed as y, openBlock as r, createElementBlock as a, mergeProps as k, unref as t, createElementVNode as l, normalizeClass as s, renderSlot as n, toDisplayString as $, createCommentVNode as c } from "vue";
import "../../hooks/use-z-index.js";
import { useDraggable as R } from "../../hooks/use-draggable.js";
import { dialogContentProps as v, dialogContentEmits as E } from "./dialog-content.js";
import { dialogInjectionKey as j } from "./token.js";
const B = { role: "heading" }, z = /* @__PURE__ */ h({
  __name: "dialog-content",
  props: v,
  emits: E,
  setup(f, { emit: p }) {
    const g = f, u = p, { dialogRef: i, headerRef: d, ns: o } = C(j), b = () => {
      u("close");
    }, m = y(() => g.draggable);
    return R(i, d, m), (e, D) => (r(), a("div", k({
      ref_key: "dialogRef",
      ref: i,
      class: [t(o).b(), e.dialogClass, t(o).is("draggable", m.value), e.customClass]
    }, e.$attrs, { tabindex: "-1" }), [
      l("header", {
        ref_key: "headerRef",
        ref: d,
        class: s(t(o).e("header"))
      }, [
        n(e.$slots, "header", {}, () => [
          l("span", B, $(e.title), 1)
        ]),
        e.showClose ? (r(), a("button", {
          key: 0,
          class: s(t(o).e("close")),
          type: "button",
          onClick: b
        }, " × ", 2)) : c("", !0)
      ], 2),
      l("div", {
        class: s(t(o).e("body"))
      }, [
        n(e.$slots, "default")
      ], 2),
      e.$slots.footer ? (r(), a("footer", {
        key: 0,
        class: s(t(o).e("footer"))
      }, [
        n(e.$slots, "footer")
      ], 2)) : c("", !0)
    ], 16));
  }
});
export {
  z as default
};
